import { createSearchParams } from "react-router-dom";
import apiRequestGlobal, { apiRequestForm } from "../Axios/axios.config";

interface IPostRequest {
  url: string;
  data?: any;
}

const handleGlobalPostRequest = ({ url, data }: IPostRequest) => {
  return apiRequestGlobal.post(url, data).then((response) => response?.data);
};

const handleGlobalPatchRequest = ({ url, data }: IPostRequest) => {
  return apiRequestGlobal.patch(url, data).then((response) => response?.data);
};

const handleGlobalPutRequest = ({ url, data }: IPostRequest) => {
  return apiRequestGlobal.put(url, data).then((response) => response?.data);
};

const handleGlobalDeleteRequest = ({ url, data }: IPostRequest) => {
  return apiRequestGlobal
    .delete(url, { data })
    .then((response) => response?.data);
};

const handleGlobalPostFormRequest = ({ url, data }: IPostRequest) => {
  return apiRequestForm.post(url, data).then((response) => response?.data);
};

interface IGetRequest {
  url: string;
  searchParams?: any;
  signal?: AbortSignal;
}

//PAGINATION PURPOSE (FOR EXAMPLE: /api/v1/locations/states?filter[name]=lagos&page=1)
const handleGlobalGetRequestQuery = ({
  url,
  searchParams = {},
  signal,
}: IGetRequest) => {
  const searchParamsObject = createSearchParams(searchParams).toString();
  return apiRequestGlobal
    .get(url + "?" + searchParamsObject, { signal })
    .then((response) => response?.data);
};

export {
  handleGlobalGetRequestQuery,
  handleGlobalDeleteRequest,
  handleGlobalPatchRequest,
  handleGlobalPostRequest,
  handleGlobalPostFormRequest,
  handleGlobalPutRequest,
};
